import { render, staticRenderFns } from "./SectionSubItem.vue?vue&type=template&id=140aa490"
import script from "./SectionSubItem.vue?vue&type=script&lang=js"
export * from "./SectionSubItem.vue?vue&type=script&lang=js"
import style0 from "./SectionSubItem.vue?vue&type=style&index=0&id=140aa490&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports